<template>
  <div id="DocumentLimitTransactionLoanInformation" class="sun not-full" v-if="loan">
    <div class="title">대출 정보</div>
    <table>
      <tr v-if="mode != 'loan'">
        <td>계약기간</td>
        <td>대출금 지급일로부터 2년</td>
      </tr>
      <tr>
        <td>만기일</td>
        <td>
          <p style="margin-bottom: 5px;">대출금 지급일로부터</p>
          <GuideInput
            ref="first_input"
            :guideValue="loan.offer.period_in_days"
            :isEqual.sync="isEqualPeriod"
            @update:isEqual="checkAll"
            unit="일"
          />
        </td>
      </tr>
      <tr>
        <td>{{ mode != 'loan' ? '한도 금액' : '대출 금액' }}</td>
        <td>
          <GuideInput
            :guideValue="loan.amount"
            :isEqual.sync="isEqualAmount"
            @update:isEqual="checkAll"
            unit="원"
          />
        </td>
      </tr>
      <tr>
        <td>대출지급방법</td>
        <td v-if="mode != 'loan'">
          카드매출, ㈜우아한형제들 매출에 의해 자동 산정된 금액을 한도내에서
          재대출 가능
        </td>
        <td v-if="mode == 'loan'">
          제신고 된 (주){{
            user.collection_account.bank == '50'
              ? '웰컴저축은행'
              : 'BNK경남은행'
          }}
          계좌에서 발생되는 카드매출 입금액의 50%를 매일 상환
        </td>
      </tr>
      <tr>
        <td>대출실행금액</td>
        <td>
          카드매출, ㈜우아한형제들 매출에 의해 자동산정(비상금 서비스의 경우
          웹페이지/앱 상에서 본인이 신청한 금액)
        </td>
      </tr>
      <tr v-if="mode != 'loan'">
        <td>변제기간</td>
        <td>
          매 건 별 지급일로부터 {{ loan.offer.period_in_days }}일이내 상환(비상금 서비스의 경우 웹 페이지/앱
          상에서 안내한 기간)
        </td>
      </tr>
      <tr>
        <td>중도상환수수료</td>
        <td>
          없음
        </td>
      </tr>
    </table>
    <div class="agree" ref="step21">
      대출 정보에 대한 내용에
      <button
        @click="agree()"
        :style="{ color: isComplete ? '#1baaf1' : '#727d8c' }"
      >
        확인함
      </button>
    </div>
  </div>
</template>

<script>
// Service Section
import AuthService from '@/service/auth/AuthService'
import LoanService from '@/service/loan/LoanService'
import GuideInput from './GuideInput.vue'

// Variable Section
let self

export default {
  components: { GuideInput },
  name: 'DocumentLimitTransactionLoanInformation',
  props: ['isAgreed', 'mode'],
  data: function () {
    return {
      user: null,
      loan: null,
      isComplete: false,
      isEqualAmount: false,
      isEqualPeriod: false
    }
  },
  computed: {},
  async created() {
    self = this
    self.user = AuthService.getProfile()
    if (self.isAgreed) {
      self.isComplete = true
    }
    self.loan = await LoanService.getCurrentLoan()
  },
  destroyed() {},
  methods: {
    agree() {
      this.isComplete = !this.isComplete
      this.checkAll()
    },
    checkAll() {
      if (this.isComplete && this.isEqualAmount && this.isEqualPeriod) {
        this.complete()
      } else {
        this.notcomplete()
      }
    },
    complete() {
      this.$emit('complete')
    },
    notcomplete() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="scss" scoped>
#DocumentLimitTransactionLoanInformation {
  padding-top: 30px;

  .title {
    font-weight: 900;
    font-size: 16px;
    line-height: 1.5;
    color: #333333;
  }

  table {
    width: 100%;
    border-top: solid 1px #727d8c;
    border-collapse: collapse;
    margin-top: 11px;
    tr {
      border-bottom: solid 1px #d7e1ea;
      td {
        height: 48px;
      }
      td:first-child {
        width: calc(136% / 325 * 100);
        background-color: #f4faff;
        font-weight: 600;
        font-size: 15px;
        line-height: 2.13;
        text-align: center;
      }
      td:last-child {
        font-size: 14px;
        line-height: 2;
        text-align: left;
        padding: 13px 20px;
        font-size: 16px;
        line-height: 1.38;
        letter-spacing: -0.3px;
      }
    }
  }

  .agree {
    width: 100%;
    font-weight: 600;
    font-size: 16px;
    line-height: 48px;
    margin-top: 12px;

    button {
      width: 80px;
      height: 48px;
      border-radius: 4px;
      border: solid 1px #d7e1ea;
      background-color: #ffffff;
      font-size: 15px;
      line-height: 1.6;
      color: #727d8c;
      float: right;
    }
  }
}
</style>
